import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, makeObservable, } from 'mobx';
import { CirclePicker } from 'react-color';

import { PromiseCompletion } from '@classes/PromiseCompletion';
import { type IModalDialogContent, type ModalButtonOptions, ModalButtonType, type ModalDialogOptions, ModalWindow } from '@components/Modal';

export type CreateNoteDialogProps = {
};

export type CreateNoteParameters = {
  name: string;
  color: string;
}

@observer
export default class CreateNoteDialog extends React.Component<CreateNoteDialogProps> implements IModalDialogContent<CreateNoteParameters> {
  @observable private _name: string;
  @observable private _color: string;
  private _loader: PromiseCompletion = new PromiseCompletion();

  constructor(props: CreateNoteDialogProps){
    super(props);    
    makeObservable(this);
    
    this._name = 'New note';
    this._color = '#ffffff';
  }

  public getModalOptions(window: ModalWindow<CreateNoteParameters>): ModalDialogOptions<CreateNoteParameters> {
    const buttons: ModalButtonOptions<CreateNoteParameters>[] = [];
    
    buttons.push({
      type: ModalButtonType.Cancel,
      onClick: () => {
        window.close();
      }
    });
    buttons.push({
      title: 'Create',
      type: ModalButtonType.Save,
      onClick: () => {
        this._onSaveClick(window);
      }
    });

    return {
      title: `Create Note`,
      width: 600,
      buttons: buttons,
      loader: this._loader
    };
  }

  render(){
    return (
      <>
        <div className="form-group">
          <label className="form-control-label">Name</label>
          <input className="form-control" type="text" value={this._name} onChange={(e) => this._name = e.target.value} />
        </div>

        <div className="form-group">
          <label className="form-group-label">Color</label>
          <CirclePicker color={this._color} onChange={(e) => this._color = e.hex}/>
        </div>
      </>
    );
  }
  
  @action.bound
  private _onSaveClick(window: ModalWindow<CreateNoteParameters>){
    window.close(ModalButtonType.Create, {
      name: this._name,
      color: this._color
    });
  }
}